<template>
  <validation-provider
    v-slot="{ errors }"
    mode="eager"
    :name="tag.description"
    :rules="tag.custom_settings.validation || ''"
  >
    <div :id="`form-tags-${tag.name}-${uniqid}`" class="select-container">
      <v-combobox
        :id="`form-combobox-${tag.name}-${uniqid}`"
        v-model="formData"
        :label="tag.description"
        :multiple="!singleValue"
        dense
        outlined
        chips
        deletable-chips
        small-chips
        :items="dic"
        item-text="value"
        item-value="term"
        :return-object="false"
        :error-messages="errors"
        :readonly="readonly"
        :disabled="disabled"
        :attach="attachFixed ? false : `#form-tags-${tag.name}-${uniqid}`"
        class="sv-autocomplete"
      />
    </div>
  </validation-provider>
</template>

<script>
import { computed } from "vue";
import uniqueId from "lodash/uniqueId";

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    tag: {
      type: Object,
      required: true
    },
    dic: {
      type: Array,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    attachFixed: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    uniqid() {
      return uniqueId();
    }
  },

  setup(props, { emit }) {
    const singleValue = computed(
      () => props.tag.custom_settings?.single_value || false
    );

    const formData = computed({
      get: () => {
        if (singleValue.value) {
          return props.value[0];
        } else {
          return props.value;
        }
      },
      set: val => {
        if (singleValue.value) {
          emit("input", [val]);
        } else {
          emit("input", val);
        }
      }
    });

    return {
      singleValue,
      formData
    };
  }
};
</script>
<style scoped>
.select-container {
  position: relative;
}
</style>
